module.exports = __webpack_public_path__ + "static/media/vg.a796b16d.svg";